import React from "react";
import banner_inicio from "../../assets/img/Banner_Inicio.png";
import NavTemporal from "./NavTemporal";


const Banner_Inicio = () => {
    return (
        <React.Fragment>
            <div>


                <img className="banner_inicio " src={banner_inicio} />

            </div>
        </React.Fragment>
    )
}
export default Banner_Inicio;